import script from "./NewsPageStoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryModal.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryModal.vue?vue&type=style&index=0&id=6046dadc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6046dadc"]])

export default __exports__